import React from "react";
import {FieldTableCellProps, getTableCellStyle} from "../../../../../render/table/table-cell";


export default function FieldTaskProgressItems_TableCell(props: FieldTableCellProps){

    const minWidth = 80


    let value = null
    if (
        !!props.listItem.task.progressSubItems?.total
        && !!props.listItem.task.progressSubItems?.done
    ) {
        value = gd.utils.floorToDecimals(100 * props.listItem.task.progressSubItems.done/props.listItem.task.progressSubItems.total, 0)
    }

    const classes = Classes("cell-flex ui5-txt-less-important-small", props.column.id)
    const style: style = getTableCellStyle(props)
    const progressClasses = Classes("ui5-progress", "in-ui5-field", {
        // "flex-row-center-center": style.width < minWidth
    });

    const showProgress = style.width && (style.width as number) > minWidth

    return(
        <div
            className={classes}
            style={style}
        >
            {!_.isNil(value) && (
                <div className={progressClasses}>
                    {showProgress && (
                        <div className="progress-bg">
                            {!!value && <div className="progress-line" style={{width: '{0}%'.f(value)}}/>}
                        </div>
                    )}

                    <div
                        className={Classes(showProgress && "progress-label", "ui5-txt-less-important-small", "txt-truncate")}>
                        {props.listItem.task.progressSubItems.done + "/" + props.listItem.task.progressSubItems.total}
                    </div>
                </div>
            )}
        </div>
    )
}
